(ns app.front.file.download
  (:require [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [core.http]
            [potpuri.core :as p]))


(defn download-href [command params]
  (str (core.http/command-name->path command)
       "?"
       (->> params
            (map (fn [[k v]] (str (name k) "=" v)))
            (str/join "&"))))


(defn download-link [command params text opts]
  (cc/link (p/assoc-if {:href     (download-href command params)
                        :download ""}
                       :class-name (:class opts))
           text))


(defn download-button [command params text opts]
  (cc/button (p/assoc-if {:icon             i/download
                          :icon-description text
                          :href             (download-href command params)
                          :kind             (or (:kind opts)
                                                :tertiary)
                          :size             (or (:size opts)
                                                :default)
                          :download         (or (:download-filename opts) "")}
                         :class-name (:class opts))
             text))


(defn download-file-link
  "Renders a simple link for downloading a file with the given command.
   Link text defaults to filename, but can be overridden with `:text` key in `opts`, which
   can also include a css class string under the key `:class`.
   Setting `:original? true` in `opts` makes this download the original"
  [file {:keys [original? command] :as opts}]
  ^{:key (str "file-" (:db/id file) "-download")}
  [download-link
   command
   (p/assoc-if {"file-id"  (:db/id file)
                "download" "true"}
               "original" (when original? "true"))
   (or (:text opts) (:file/filename file))
   opts])


(defn download-workspace-file-link
  "Renders a simple link for downloading an \"application file\".
   Link text defaults to filename, but can be overridden with `:text` key in `opts`, which
   can also include a css class string under the key `:class`.
   Setting `:original? true` in `opts` makes this download the original"
  [file opts]
  [download-file-link file (assoc opts :command :file/download-workspace-file)])


(defn download-workspace-file-button
  "Renders a button for downloading an \"application file\".
   Button text defaults to filename, but can be overridden with `:text` key in `opts`, which
   can also include Carbon button `:size` and `:kind` options and a CSS class string under the key `:class`."
  [file opts]
  ^{:key (str "application-file-" (:db/id file) "-download")}
  [download-button
   :file/download-workspace-file
   {"file-id"  (:db/id file)
    "download" "true"}
   (or (:text opts) (:file/filename file))
   opts])


(defn download-council-decision-file-button
  "Public version of the download-workspace-file-button for downloading council decisions."
  [file-id token workspace-id opts]
  [download-button
   :file/download-council-decision-file
   {"file-id"      file-id
    "user/token"   token
    "workspace-id" workspace-id
    "download"     "true"}
   (:text opts)
   opts])
